import util from '@bmp-vue/core/api/util'

const controller = 'RelatorioRamificacaoResolvida'
export default Object.assign({}, util.GetCrud(controller, ['getall']), {
    GetDetalhamentoByCodigoRamificacao: function (codigo) {
        return util.Axios.Get(controller + '/' + codigo)
    },
})

